import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

const HEARTBEAT_INTERVAL = 60000; // 1 minute

export const useSessionTracker = (userId: string | undefined) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!userId) return;

    const trackSession = async () => {
      try {
        // Get user's IP address
        let ip = '';
        try {
          const ipResponse = await fetch('https://api.ipify.org?format=json');
          if (ipResponse.ok) {
            const ipData = await ipResponse.json();
            ip = ipData.ip;
          }
        } catch (e) {
          console.error('Failed to get IP:', e);
        }

        await supabase.functions.invoke('auth-wallet', {
          body: {
            action: 'track_session',
            user_id: userId,
            ip_address: ip,
            user_agent: navigator.userAgent,
          }
        });
      } catch (e) {
        console.error('Failed to track session:', e);
      }
    };

    // Track immediately on login
    trackSession();

    // Set up heartbeat
    intervalRef.current = setInterval(trackSession, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [userId]);
};
